module.exports = __webpack_public_path__ + "img/HNYT087_17.d9062000.gif";